// Common variables and constants used across the application

// Tab options for campaign type settings
export const TAB_OPTIONS = [
  { id: 'all', label: 'All' },
  { id: 'crowdfunding', label: 'Crowdfunding' },
  { id: 'presales', label: 'Presales' },
  { id: 'product-drop', label: 'Product Drop' },
];

// Initial values for campaign settings
export const INITIAL_VALUES = {
  // Custom CSS and Script
  customCss: '',
  customScript: '',
  
  // Crowdfunding specific
  crowdfunding: {
    // Text Content
    goalText: 'Goal: {goal}',
    raisedText: 'Raised: {raised}',
    backerText: 'Backers: {backers}',
    timeLeftText: 'Time left: {days} day, {hours} hour, {minutes} minutes',
    fundedText: '{percentage}% funded',
    progressMessage: "You've reached the target! Keep contributing to unlock even more amazing rewards!",

    // Layout & Style
    widgetBorderRadius: 8,
    buttonStyle: 'rounded',

    // Typography
    headerFontSize: 16,
    primaryFontSize: 14,
    secondaryFontSize: 13,
    buttonFontSize: 14,

    // Colors
    backgroundColor: '#ffffff',
    headerColor: '#000000',
    subtitleColor: '#6b7280',
    textColor: '#000000',
    progressBarColor: '#000000',
    progressBarBackgroundColor: '#e1e5e9',
    widgetBorderColor: '#e1e5e9',

    // Reward Settings
    rewardTitle: 'Premium Bundle',
    rewardDescription: 'Perfect for professionals. Get more with less.',
    rewardSeeDetailsButton: 'See details',
    rewardClaimButton: 'Claim this perk',
    rewardIncludedLabel: 'Included',
    rewardCardBackgroundColor: '#ffffff',
    rewardCardBorderColor: '#e1e5e9',
    rewardTitleColor: '#000000',
    rewardDescriptionColor: '#6b7280',
    rewardPriceColor: '#000000',
    rewardStrikethroughPriceColor: '#000000',
    rewardSeeDetailsButtonColor: '#000000',
    rewardSeeDetailsButtonTextColor: '#000000',
    rewardSeeDetailsButtonBackgroundColor: '#ffffff',
    rewardClaimButtonColor: '#000000',
    rewardClaimButtonTextColor: '#ffffff',
  },

  // Presales specific
  presales: {
    // Text Content
    preOrderText: 'Pre-orders: {raised} / Target: {goal}',
    backerText: 'Pre-orderers: {backers}',
    timeLeftText: 'Ends in: {time}',
    buttonText: 'Pre-order now',
    earlyBirdText: 'Early bird special!',
    whenLiveTitle: 'PRE-SALE IS LIVE! 🔥',
    whenLiveButton: 'SHOP THE PRE-SALE',
    claimedPercentageText: '{percentage}% Claimed',
    afterLiveTitle: 'THE EXCLUSIVE PRE-SALE HAS ENDED',
    afterLiveMessage: 'All units are sold out. Thank you for the incredible response!',
    afterLiveButton: 'NOTIFY ME FOR RESTOCK',

    // Layout & Style
    widgetBorderRadius: 8,
    buttonStyle: 'rounded',

    // Typography
    headerFontSize: 16,
    primaryFontSize: 14,
    secondaryFontSize: 13,
    buttonFontSize: 14,

    // Colors
    backgroundColor: '#ffffff',
    headerColor: '#000000',
    subtitleColor: '#6b7280',
    textColor: '#000000',
    progressBarColor: '#000000',
    progressBarBackgroundColor: '#e1e5e9',
    widgetBorderColor: '#e1e5e9',
    buttonBackgroundColor: '#000000',
    buttonTextColor: '#ffffff',
    afterLiveTitleColor: '#ef4444',

    // Notify Me Modal Settings
    notifyMeModalTitle: 'Notify Me',
    notifyMeModalDescription: 'Enter your email to be notified when this product becomes available.',
    notifyMeEmailPlaceholder: 'Enter your email',
    notifyMeButtonText: 'Notify me',
    notifyMeModalBackgroundColor: '#ffffff',
    notifyMeModalTitleColor: '#1a1a1a',
    notifyMeModalDescriptionColor: '#666666',
    notifyMeButtonBackgroundColor: '#4a90e2',
    notifyMeButtonTextColor: '#ffffff',
  },

  // Product Drop specific
  productDrop: {
    // Text Content
    goalText: 'Limited: {goal}',
    raisedText: 'Sold: {raised}',
    backerText: 'Buyers: {backers}',
    timeLeftText: 'Ends in: {time}',
    buttonText: 'Buy now',
    urgencyText: 'Only {left} left!',
    beforeLiveTitle: 'GOES LIVE IN:',
    beforeLiveButton: 'NOTIFY ME',
    beforeLiveDetails: 'Time left: {days} day, {hours} hour, {minutes} minutes',
    whenLiveTitle: 'DROP IS LIVE! SELLING FAST 🔥',
    whenLiveButton: 'BUY NOW ⚡',
    claimedPercentageText: '{percentage}% Claimed',
    whenLiveLimit: 'Limited to {limit} per customer.',
    afterLiveTitle: 'SOLD OUT!',
    afterLiveMessage: 'All units are sold out. Thank you for the incredible response!',
    afterLiveButton: 'NOTIFY ME FOR RESTOCK',

    // Layout & Style
    widgetBorderRadius: 8,
    buttonStyle: 'rounded',

    // Typography
    headerFontSize: 16,
    primaryFontSize: 14,
    secondaryFontSize: 13,
    buttonFontSize: 14,

    // Colors
    backgroundColor: '#ffffff',
    headerColor: '#000000',
    subtitleColor: '#6b7280',
    textColor: '#000000',
    progressBarColor: '#000000',
    progressBarBackgroundColor: '#e1e5e9',
    widgetBorderColor: '#e1e5e9',
    timerTextColor: '#000000',
    buttonBackgroundColor: '#000000',
    buttonTextColor: '#ffffff',
    afterLiveTitleColor: '#ef4444',

    // Notify Me Modal Settings - Before Live
    notifyMeBeforeModalTitle: 'Notify Me',
    notifyMeBeforeModalDescription: 'Enter your email to be notified when this product drops.',
    notifyMeBeforeEmailPlaceholder: 'Enter your email',
    notifyMeBeforeButtonText: 'Notify me',
    notifyMeBeforeModalBackgroundColor: '#ffffff',
    notifyMeBeforeModalTitleColor: '#1a1a1a',
    notifyMeBeforeModalDescriptionColor: '#666666',
    notifyMeBeforeButtonBackgroundColor: '#4a90e2',
    notifyMeBeforeButtonTextColor: '#ffffff',

    // Notify Me Modal Settings - After Live (Restock)
    notifyMeAfterModalTitle: 'Notify Me',
    notifyMeAfterModalDescription: 'Enter your email to be notified when this product is restocked.',
    notifyMeAfterEmailPlaceholder: 'Enter your email',
    notifyMeAfterButtonText: 'Notify me',
    notifyMeAfterModalBackgroundColor: '#ffffff',
    notifyMeAfterModalTitleColor: '#1a1a1a',
    notifyMeAfterModalDescriptionColor: '#666666',
    notifyMeAfterButtonBackgroundColor: '#4a90e2',
    notifyMeAfterButtonTextColor: '#ffffff',
  },
};

// Campaign type options for campaign edit form
export const CAMPAIGN_TYPE_OPTIONS = [
  { label: 'Select campaign type...', value: '', disabled: true },
  { label: 'Crowdfunding', value: '1' },
  { label: 'PreSales', value: '0' },
  { label: 'Product Drop', value: '2' },
];

// Helper function to parse UTC offset from label
function parseUTCOffset(label) {
  // Extract UTC offset from label like "(UTC-05:00)" or "(UTC+02:00)" or "(UTC+05:30)"
  const match = label.match(/\(UTC([+-])(\d{2}):(\d{2})\)/);
  if (!match) {
    // Handle special cases like "(UTC+12:00)" without parentheses or other formats
    const altMatch = label.match(/UTC([+-])(\d{1,2}):?(\d{2})?/);
    if (altMatch) {
      const sign = altMatch[1] === '+' ? 1 : -1;
      const hours = parseInt(altMatch[2]) || 0;
      const minutes = parseInt(altMatch[3]) || 0;
      return sign * (hours + minutes / 60);
    }
    return 0; // Default to UTC if can't parse
  }
  
  const sign = match[1] === '+' ? 1 : -1;
  const hours = parseInt(match[2]);
  const minutes = parseInt(match[3]);
  return sign * (hours + minutes / 60);
}

// Timezone options for campaign forms - sorted by UTC offset (negative to positive)
const TIME_ZONE_OPTIONS_UNSORTED = [
  { label: "(UTC+00:00) Monrovia, Reykjavik", value: "Africa/Abidjan" },
  { label: "(UTC+00:00) Monrovia, Reykjavik", value: "Africa/Accra" },
  { label: "(UTC+02:00) Cairo", value: "Africa/Cairo" },
  { label: "(UTC+00:00) Casablanca", value: "Africa/Casablanca" },
  { label: "(UTC+02:00) Harare, Pretoria", value: "Africa/Johannesburg" },
  { label: "(UTC+01:00) West Central Africa", value: "Africa/Lagos" },
  { label: "(UTC+03:00) Nairobi", value: "Africa/Nairobi" },
  { label: "(UTC+02:00) Windhoek", value: "Africa/Windhoek" },

  { label: "(UTC-10:00) Aleutian Islands", value: "America/Adak" },
  { label: "(UTC-09:00) Alaska", value: "America/Anchorage" },
  { label: "(UTC-03:00) Buenos Aires", value: "America/Argentina/Buenos_Aires" },
  { label: "(UTC-05:00) Bogota, Lima, Quito", value: "America/Bogota" },
  { label: "(UTC-04:00) Caracas", value: "America/Caracas" },
  { label: "(UTC-06:00) Central Time (US & Canada)", value: "America/Chicago" },
  { label: "(UTC-07:00) Mountain Time (US & Canada)", value: "America/Denver" },
  { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "America/Detroit" },
  { label: "(UTC-06:00) Central America", value: "America/El_Salvador" },
  { label: "(UTC-04:00) Atlantic Time (Canada)", value: "America/Halifax" },
  { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "America/Los_Angeles" },
  { label: "(UTC-06:00) Guadalajara, Mexico City", value: "America/Mexico_City" },
  { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "America/New_York" },
  { label: "(UTC-07:00) Arizona", value: "America/Phoenix" },
  { label: "(UTC-04:00) Santiago", value: "America/Santiago" },
  { label: "(UTC-03:00) Brasilia", value: "America/Sao_Paulo" },
  { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "America/Toronto" },
  { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "America/Vancouver" },

  { label: "(UTC+07:00) Bangkok, Hanoi", value: "Asia/Bangkok" },
  { label: "(UTC+06:00) Dhaka", value: "Asia/Dhaka" },
  { label: "(UTC+04:00) Abu Dhabi, Muscat", value: "Asia/Dubai" },
  { label: "(UTC+08:00) Beijing, Chongqing, Hong Kong", value: "Asia/Hong_Kong" },
  { label: "(UTC+07:00) Jakarta", value: "Asia/Jakarta" },
  { label: "(UTC+02:00) Jerusalem", value: "Asia/Jerusalem" },
  { label: "(UTC+05:00) Islamabad, Karachi", value: "Asia/Karachi" },
  { label: "(UTC+05:45) Kathmandu", value: "Asia/Kathmandu" },
  { label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "Asia/Kolkata" },
  { label: "(UTC+08:00) Kuala Lumpur, Singapore", value: "Asia/Kuala_Lumpur" },
  { label: "(UTC+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
  { label: "(UTC+03:00) Kuwait, Riyadh", value: "Asia/Qatar" },
  { label: "(UTC+09:00) Seoul", value: "Asia/Seoul" },
  { label: "(UTC+08:00) Beijing, Chongqing, Hong Kong", value: "Asia/Shanghai" },
  { label: "(UTC+08:00) Kuala Lumpur, Singapore", value: "Asia/Singapore" },
  { label: "(UTC+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },

  { label: "(UTC+09:30) Adelaide", value: "Australia/Adelaide" },
  { label: "(UTC+10:00) Brisbane", value: "Australia/Brisbane" },
  { label: "(UTC+09:30) Darwin", value: "Australia/Darwin" },
  { label: "(UTC+10:00) Hobart", value: "Australia/Hobart" },
  { label: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "Australia/Melbourne" },
  { label: "(UTC+08:00) Perth", value: "Australia/Perth" },
  { label: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "Australia/Sydney" },
  { label: "(UTC+12:00) Auckland, Wellington", value: "Pacific/Auckland" },
  { label: "(UTC+12:00) Fiji", value: "Pacific/Fiji" },

  { label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome", value: "Europe/Amsterdam" },
  { label: "(UTC+02:00) Athens, Bucharest", value: "Europe/Athens" },
  { label: "(UTC+01:00) Belgrade, Bratislava", value: "Europe/Belgrade" },
  { label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome", value: "Europe/Berlin" },
  { label: "(UTC+00:00) Dublin, Edinburgh, Lisbon", value: "Europe/Dublin" },
  { label: "(UTC+02:00) Helsinki, Kyiv, Riga", value: "Europe/Helsinki" },
  { label: "(UTC+03:00) Istanbul", value: "Europe/Istanbul" },
  { label: "(UTC+00:00) Dublin, Edinburgh, Lisbon", value: "Europe/Lisbon" },
  { label: "(UTC+00:00) Dublin, Edinburgh, Lisbon", value: "Europe/London" },
  { label: "(UTC+01:00) Brussels, Madrid, Paris", value: "Europe/Madrid" },
  { label: "(UTC+03:00) Moscow", value: "Europe/Moscow" },
  { label: "(UTC+01:00) Brussels, Madrid, Paris", value: "Europe/Paris" },
  { label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome", value: "Europe/Rome" },
  { label: "(UTC+01:00) Stockholm, Vienna", value: "Europe/Stockholm" },
  { label: "(UTC+01:00) Stockholm, Vienna", value: "Europe/Vienna" },
  { label: "(UTC+01:00) Sarajevo, Skopje, Warsaw", value: "Europe/Warsaw" },

  { label: "(UTC+00:00) UTC", value: "UTC" },
  { label: "(UTC+00:00) UTC", value: "Etc/GMT" },
  { label: "(UTC-12:00) International Date Line West", value: "Etc/GMT+12" },
  { label: "(UTC+12:00) International Date Line East", value: "Etc/GMT-12" },
];

// Sort timezone options by UTC offset (negative to positive)
export const TIME_ZONE_OPTIONS = TIME_ZONE_OPTIONS_UNSORTED.sort((a, b) => {
  const offsetA = parseUTCOffset(a.label);
  const offsetB = parseUTCOffset(b.label);
  return offsetA - offsetB; // Sort from negative to positive
});

// Initial form values function for campaign edit form
export const getInitialValues = () => ({
  // Campaign fields
  campaign_name: '',
  campaign_description: '',
  campaign_banner_link: '',
  campaign_type: '1', // Default to Crowdfunding for new campaigns
  campaign_status: '1',
  goal_type: '0',
  number_of_items: 0,
  total_amount: 0,
  is_auto_end_campaign: '0',
  is_add_start_point: '0',
  initial_fund: 0,
  initial_backers: 0,
  duration_type: '0',
  campaign_start_datetime: '',
  campaign_end_datetime: '',
  timezone: 'UTC',
  is_limit_inventory: '0',
  available_inventory: null,
  is_show_presale_target: '0',
  product_drop_per_customer_limit: 1,
  product_drop_total_limit: null,
  order_tags: '',
  customer_tags: '',
  current_funding: 0,
  current_backers: 0,
  current_items_sold: 0,
  initial_backers_count: 0,
  is_deleted: '0',

  // Products and rewards arrays
  products: [],
  rewards: [],
  rewards_count: 0,

  // UI helper fields
  showEndDateCrowdfunding: false,
  showEndDate: false,
  addStartPoint: false,

  // UI state fields for form management
  orderTagInput: '',
  customerTagInput: '',
  timeZone: 'UTC',
  perCustomerLimit: '1',
  totalDropLimit: '',
  limitInventory: true,
  availableInventory: 100,
  initial_items_sold_preSale: 0,
  enableProductLimitPerOrder: false,
  productLimitPerOrder: null,
  showPresalesTarget: true,
  orderTags: [],
  customerTags: []
});

// Metafield constants for campaign management
export const METAFIELD_CONFIG = {
  NAMESPACE: 'custom',
  KEY: 'campaign_data',
  TYPE: 'json'
};

// Default preview settings
export const DEFAULT_PREVIEW_SETTINGS = {
  backgroundColor: '#ffffff',
  headerColor: '#000000',
  subtitleColor: '#6b7280',
  textColor: '#000000',
  progressBarColor: '#000000',
  widgetBorderRadius: 8,
  buttonStyle: 'rounded',
  buttonBackgroundColor: '#000000',
  buttonTextColor: '#ffffff',
  campaignTitle: 'Demo Funding Campaign',
  goalText: 'Goal: {goal}',
  raisedText: 'Raised: {raised}',
  backerText: 'Backers: {backers}',
  timeLeftText: 'Time left: {time}',
  progressMessage: "You've reached the target! Keep contributing to unlock even more amazing rewards!",
  whenLiveTitle: 'PRE-SALE IS LIVE! 🔥',
  whenLiveButton: 'SHOP THE PRE-SALE',
  whenLiveEndTime: 'This exclusive access ends in {time}.',
  afterLiveTitle: 'THE EXCLUSIVE PRE-SALE HAS ENDED',
  afterLiveMessage: 'The main event is next. Get ready for the public launch!',
  afterLiveButton: 'NOTIFY ME FOR RESTOCK',
  rewardSeeDetailsButton: 'See details',
  rewardClaimButton: 'Claim this perk',
  rewardSeeDetailsButtonColor: '#000000',
  rewardSeeDetailsButtonBackgroundColor: '#ffffff',
  rewardClaimButtonColor: '#000000',
  rewardClaimButtonTextColor: '#ffffff',
};

